module.exports = __webpack_public_path__ + "img/1.e41fc803.png";